import {
  GET_FAULTY_SENSORS,
  GET_FAULTY_SENSORS_ERROR,
  GET_FAULTY_SENSORS_SUCCESS,
  GET_STATUS_HISTORY,
  GET_STATUS_HISTORY_ERROR,
  GET_STATUS_HISTORY_SUCCESS,
  IGetStatusHistorySuccess,
  IInstallationState,
  IRefillTank,
  IRequestButtonPress,
  IRequestButtonPressPayload,
  IRequestComponents,
  IRequestComponentsError,
  IRequestComponentsSuccess,
  IRequestSingleComponents,
  IRequestSingleComponentsError,
  IRequestSingleComponentsSuccess,
  IRequestSingleComponentsSuccessPayload,
  ISetPressureChamberBeverage,
  IStatusHistory,
  REFILL_TANK,
  REQUEST_BUTTON_PRESS,
  REQUEST_COMPONENTS,
  REQUEST_COMPONENTS_ERROR,
  REQUEST_COMPONENTS_SUCCESS,
  REQUEST_SINGLE_COMPONENTS,
  REQUEST_SINGLE_COMPONENTS_ERROR,
  REQUEST_SINGLE_COMPONENTS_SUCCESS,
  SET_PRESSURE_CHAMBER_BEVERAGE,
  SET_PRESSURE_CHAMBER_BEVERAGE_ERROR
} from "./types";
import { IBeverage } from "../beers/types";

export const requestButtonPress = (payload: IRequestButtonPressPayload): IRequestButtonPress => ({
  type: REQUEST_BUTTON_PRESS,
  payload
});

export const requestComponents = (): IRequestComponents => ({
  type: REQUEST_COMPONENTS
});

export const requestComponentsError = (): IRequestComponentsError => ({
  type: REQUEST_COMPONENTS_ERROR
});

export const requestComponentsSuccess = (data: any): IRequestComponentsSuccess => ({
  type: REQUEST_COMPONENTS_SUCCESS,
  payload: data
});

export const requestSingleComponents = (locationId: string): IRequestSingleComponents => ({
  type: REQUEST_SINGLE_COMPONENTS,
  payload: locationId
});

export const requestSingleComponentsError = (): IRequestSingleComponentsError => ({
  type: REQUEST_SINGLE_COMPONENTS_ERROR
});

export const requestSingleComponentsSuccess = (
  data: IRequestSingleComponentsSuccessPayload
): IRequestSingleComponentsSuccess => ({
  type: REQUEST_SINGLE_COMPONENTS_SUCCESS,
  payload: data
});

export const setPressureChamberBeverage = (
  outletId: string,
  thingId: string,
  beverage: IBeverage,
  oldBeverageName?: string,
  isBeerDrive?: boolean,
  isSteelKeg?: boolean
): ISetPressureChamberBeverage => ({
  type: SET_PRESSURE_CHAMBER_BEVERAGE,
  payload: { outletId, thingId, beverage, oldBeverageName, isBeerDrive, isSteelKeg }
});

export const setPressureChamberBeverageError = () => ({
  type: SET_PRESSURE_CHAMBER_BEVERAGE_ERROR
});

export const getFaultySensors = (
  locationIds: string[],
  startTimestamp: number,
  endTimestamp: number
) => ({
  type: GET_FAULTY_SENSORS,
  payload: {
    locationIds,
    startTimestamp,
    endTimestamp
  }
});

export const getFaultySensorsSuccess = (faultySensors: IInstallationState["faultySensors"]) => ({
  type: GET_FAULTY_SENSORS_SUCCESS,
  payload: faultySensors
});

export const getFaultySensorsError = () => ({
  type: GET_FAULTY_SENSORS_ERROR
});

export const getStatusHistory = (outletId: string, controlUnitId: string) => ({
  type: GET_STATUS_HISTORY,
  payload: {
    outletId,
    controlUnitId
  }
});

export const getStatusHistorySuccess = (
  outletId: string,
  controlUnitId: string,
  statusHistory: IStatusHistory[]
): IGetStatusHistorySuccess => ({
  type: GET_STATUS_HISTORY_SUCCESS,
  payload: {
    outletId,
    controlUnitId,
    statusHistory
  }
});

export const getStatusHistoryError = () => ({
  type: GET_STATUS_HISTORY_ERROR
});

export const refillTank = (locationId: string, beerDriveId: string): IRefillTank => ({
  type: REFILL_TANK,
  payload: { locationId, beerDriveId }
});
